(()=>{
  const HANDLE='enshi-hidden-canyon-adventure';
  const ROOT_SELECTOR='[id^="EnshiComfort-"]';
  const SUPPORTED=new Set(['de','fr','es','it']);
  let observer=null,busy=false,queued=false;
  const reverseCache={};

  function normalize(raw){
    const value=String(raw||'').replace('_','-').toLowerCase();
    const base=value.split('-')[0];
    return SUPPORTED.has(base)?base:'';
  }

  function currentLocale(){
    const pathPart=location.pathname.split('/').filter(Boolean)[0]||'';
    const queryLocale=new URLSearchParams(location.search).get('locale');
    const candidates=[pathPart,queryLocale,window.Shopify?.locale,document.documentElement.lang];
    for(const candidate of candidates){
      const locale=normalize(candidate);
      if(locale)return locale;
    }
    return '';
  }

  function dictionaries(){return window.CNTripEnshiEuTranslations||{};}

  function reverseFor(locale){
    if(reverseCache[locale])return reverseCache[locale];
    const all=dictionaries();
    const reverse={};
    Object.keys(all).forEach((key)=>{
      Object.entries(all[key]||{}).forEach(([source,translated])=>{
        if(translated&&translated!==source)reverse[String(translated).trim()]=source;
      });
    });
    reverseCache[locale]=reverse;
    return reverse;
  }

  function translatedValue(value,locale){
    const dict=dictionaries()[locale]||{};
    const core=String(value||'').trim();
    if(!core)return value;
    const source=Object.prototype.hasOwnProperty.call(dict,core)?core:(reverseFor(locale)[core]||core);
    return Object.prototype.hasOwnProperty.call(dict,source)?dict[source]:value;
  }

  function replaceTextNode(node,locale){
    const original=node.nodeValue||'';
    const trimmed=original.trim();
    if(!trimmed)return;
    const translated=translatedValue(trimmed,locale);
    if(translated===trimmed||translated===original)return;
    const start=original.match(/^\s*/)?.[0]||'';
    const end=original.match(/\s*$/)?.[0]||'';
    node.nodeValue=start+translated+end;
  }

  function shouldSkip(element){
    if(!element)return true;
    return Boolean(element.closest('script,style,noscript,svg,template,[data-cntrip-no-translate]'));
  }

  function translateTree(host,locale){
    if(!host)return;
    const walker=document.createTreeWalker(host,NodeFilter.SHOW_TEXT);
    const nodes=[];
    while(walker.nextNode()){
      const node=walker.currentNode;
      if(!shouldSkip(node.parentElement))nodes.push(node);
    }
    nodes.forEach((node)=>replaceTextNode(node,locale));

    host.querySelectorAll('[placeholder],[title],[aria-label],[value]').forEach((element)=>{
      if(shouldSkip(element))return;
      ['placeholder','title','aria-label'].forEach((attribute)=>{
        if(!element.hasAttribute(attribute))return;
        const before=element.getAttribute(attribute)||'';
        const after=translatedValue(before,locale);
        if(after!==before)element.setAttribute(attribute,after);
      });
      if((element.matches('input[type="submit"],input[type="button"]'))&&element.hasAttribute('value')){
        const before=element.getAttribute('value')||'';
        const after=translatedValue(before,locale);
        if(after!==before)element.setAttribute('value',after);
      }
    });
  }

  function forceEnglishSource(root){
    root.querySelectorAll('[data-ecp-lang]').forEach((button)=>{
      const active=button.dataset.ecpLang==='en';
      button.classList.toggle('is-active',active);
      button.setAttribute('aria-pressed',active?'true':'false');
    });
    root.querySelectorAll('[data-ecp-copy]').forEach((element)=>{
      element.hidden=element.dataset.ecpCopy!=='en';
    });
  }

  function apply(){
    if(busy||!location.pathname.includes(`/products/${HANDLE}`))return;
    const locale=currentLocale();
    if(!locale)return;
    const root=document.querySelector(ROOT_SELECTOR);
    if(!root||!dictionaries()[locale])return;
    busy=true;
    forceEnglishSource(root);
    root.dataset.cntripLocale=locale;
    root.setAttribute('lang',locale);
    translateTree(root,locale);
    document.querySelectorAll('#EnshiAttractionsV5,[id^="EnshiTransfers-"],[id^="EnshiAuthoritySources-"]').forEach((module)=>translateTree(module,locale));
    busy=false;
  }

  function queue(){
    if(queued||busy)return;
    queued=true;
    requestAnimationFrame(()=>{queued=false;apply();});
  }

  function schedule(){
    [0,40,100,220,420,700,1100,1700,2600,4000].forEach((delay)=>setTimeout(apply,delay));
  }

  function init(){
    if(!currentLocale()||!location.pathname.includes(`/products/${HANDLE}`))return;
    schedule();
    if(!observer){
      observer=new MutationObserver(()=>{if(!busy)queue();});
      observer.observe(document.body,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['placeholder','title','aria-label','hidden','class']});
    }
    document.addEventListener('click',(event)=>{
      if(event.target.closest('[data-cntrip-product-language],[data-ecp-lang],form[action*="localization"]'))schedule();
    },true);
    document.addEventListener('shopify:section:load',schedule);
    window.addEventListener('pageshow',schedule);
    window.addEventListener('popstate',schedule);
  }

  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',init,{once:true}):init();
})();
